const Upload = (): JSX.Element => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 19.8003L15 6.60029M15 6.60029L19.5 11.5119M15 6.60029L10.5 11.5119"
      stroke="#3D3A62"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.40039 15.3003V22.8003H24.9004V15.3003"
      stroke="#3D3A62"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Upload;
